export interface IGetTripyIdOrCodeDto {
    idOrCode: string;
    includeExternal?: boolean;
}
